import { styled } from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';

import { useTranslation } from '../../../hooks';
import { useAppSelector } from '../../../reducer/hooks';
import { selectIsMobileView } from '../../../reducer/mediaSlice';
import { useEffect, useRef } from 'react';

const StyledInput = styled(OutlinedInput)(
  () => `
    flex: 1;
    height: 38px !important;
    font-size: 16px;
    border-radius: 4px;
    background-color: #F9F9F9 !important;
    border: 1px solid #F9F9F9;
    color: #333 !important;

  
    &:hover {
      border: 1px solid #F9F9F9 !important;
      outline: 0 !important;
    }

    .MuiOutlinedInput-notchedOutline {
      border-color: #DDE1E3 !important;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #DDE1E3 !important;
    }

    &.Mui-disabled {
      background-color: #3a3a3a !important;
      border: 1px solid #555555 !important;
      color: #888888 !important;
      cursor: not-allowed !important;
      opacity: 0.6;
    }

    &.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: #555555 !important;
    }

    &.Mui-disabled:hover {
      border: 1px solid #555555 !important;
    }
  
    // firefox
    &:focus-visible {
      outline: 0 !important;
    }
  );
  `
);

const RemarksTextArea = ({
  value,
  onChange,
  isDisabled,
  onFocus,
  onBlur,
}: {
  value: string;
  onChange: (e: any) => void;
  isDisabled?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
}) => {
  const { tc } = useTranslation();
  const isMobile = useAppSelector(selectIsMobileView);

  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle focus and blur to prevent dialog from being pushed away on mobile
  const handleFocus = () => {
    if (onFocus) {
      onFocus();
    }

    if (isMobile) {
      const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
      const body = document.body;
      body.style.position = 'fixed';
      body.style.top = `-${scrollY}`;
    }
  };

  const handleBlur = () => {
    if (onBlur) {
      onBlur();
    }

    if (isMobile) {
      const body = document.body;
      const scrollY = body.style.top;
      body.style.position = '';
      body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    }
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          flex: '1',
          padding: isMobile ? '24px 0 ' : '24px',
          ...(isMobile && { width: '90%' }),
        }}
      >
        <div style={{ marginRight: '24px', fontSize: '16px' }}>{tc('remarks')}</div>
        <StyledInput
          value={value}
          onChange={onChange}
          disabled={isDisabled}
          inputRef={inputRef}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
      </div>
    </>
  );
};

export default RemarksTextArea;
